import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: '16px',
        '@global': {
            '.MuiTypography-h6': {
            fontWeight: 600
            }
        }
    },
    // upload: {
    //     boxShadow: 'none',
    //     width: '89px',
    //     height: '89px',
    //     zIndex: '100',
    //     padding: '5px',
    //     outline: 'none',
    //     display: 'inline-block',
    //     borderRadius: '100%',
    //     position: 'relative'
    // },
    progress : {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    container: {
        justifyContent: 'center',
        textAlign: 'center',
        marginTop: '25px',
        outline: 'none',
        position: 'relative'
    },
    thumbsContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    thumb: {
        display: 'flex',
        borderRadius: 2,
        border: '1px solid #eaeaea',
        marginBottom: 8,
        marginRight: 8,
        width: 'inherit',
        height: 'inherit',
        padding: 4,
        boxSizing: 'border-box',
        position: 'relative'
    },
    thumbInner: {
        display: 'flex',
        minWidth: 0,
        overflow: 'hidden',
    },
    img: {
        display: 'block',
        width: '100%',
        height: '100%'
    },
    remove: {
        position: 'absolute',
        top: '-14px',
        width: '0',
        height: '0',
        right: '12px',
        cursor: 'pointer'
    },
    documentPreview: {
        margin: '15px',
        boxSizing: 'border-box',
    },
    progress: {
        height: '120px',
        width: '120px',
        border: '7px solid #cfcece',
        borderRadius: '100%'
    },
    circle: {
        borderRadius: '50%',
        border: '1px solid #2ca01c',
        width: '130px',
        height: '130px',
        boxShadow: theme.shadows[2],
        position: 'absolute',
        opacity: '0',
        top: '0',
        animation: `$scaleIn 4s infinite cubic-bezier(.36, .11, .89, .32)`,
    },
    '@keyframes scaleIn': {
        "from": {
            transform: 'scale(.5, .5)',
            opacity: '.5'
        },
        "to": {
            transform: 'scale(1.5, 1.5)',
            opacity: '0'
        }
    },
    upload: {
        boxShadow: 'none',
        width: '130px',
        height: '130px',
        zIndex: '100',
        padding: '5px',
        outline: 'none',
        display: 'inline-block',
        borderRadius: '100%',
        position: 'relative'
    },
    icon: {
        color: '#2ca01c',
        position: 'relative',
        display: 'flex',
        width: '100%',
        fontSize: '50px',
    },
    button: {
        fontWeight: 'bold',
        borderRadius: '28px',
        textTransform: 'none',
        fontFamily: 'Avenir-Regular',
        marginTop: '10px',
        outline: 'none'
    },
    animate: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
    },
    percentage: {
        color: '#2ca01c',
        fontWeight: 'bold',
        fontSize: '18px'
    }
}));


export default useStyles;
